import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CalendarPointFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM18.44 9.66V7.22H5.56V9.66H18.44ZM14.8 15.04C15.72 15.04 16.46 14.3 16.46 13.38C16.46 12.46 15.72 11.72 14.8 11.72C13.88 11.72 13.14 12.46 13.14 13.38C13.14 14.3 13.88 15.04 14.8 15.04Z" />
    </SvgIcon>
  );
});
